import type { ContentComponent } from 'services/content/components/types/FormModule'
import TextBlock from 'ui-component-library/components/00-Primitives/TextBlock'
import HeadlineThree from 'ui-component-library/components/00-Primitives/Headlines/HeadlineThree'

type Props = {
  component: ContentComponent
}

function FormModuleContent({ component }: Props) {
  switch (component.name) {
    case 'TextBlock':
      return <TextBlock {...component.props} />
    case 'SectionHeadline':
      return <HeadlineThree {...component.props} />
  }
  return null
}

export default FormModuleContent
